<template>
	<div class="page d-flex">
		<MenuComponent />
		<NotificationViewComponent />
	</div>
</template>

<script>

import MenuComponent from '@/components/user/layout/MenuComponent.vue';
import NotificationViewComponent from '@/components/user/viewComponent/notification/NotificationViewComponent.vue';

export default{
	name: 'AppsView',
  components:{
    MenuComponent,
		NotificationViewComponent,
  }
}

</script>

<style>
</style>
